<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex>
          <h1 class="mb-3">
            Questions & Answers
            <b>({{ bot.botTitle }})</b>
          </h1>
        </v-flex>
        <QAForm
          v-if="common.hasPermissions('llm', ['create'])"
          :botId="bot.botId"
          :edit="showEdit"
          :data="item"
          @submitted="() => getList()"
          @close="(v) => (showEdit = v)"
        ></QAForm>
        <v-dialog v-model="deleteDialog" width="500">
          <delete-dialog
            :title="`${item.question}`"
            @onDelete="deleteItem(item)"
            @closeDialog="deleteDialog = false"
          ></delete-dialog>
        </v-dialog>
      </v-layout>
      <v-card class="rounded-box" flat>
        <v-card-title class="pt-0 px-0">
          <v-text-field
            v-model="search"
            append-icon="search"
            class="ma-0 pa-0"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :rows-per-page-items="[
            10,
            25,
            { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
          ]"
        >
          <template v-slot:items="{ item }">
            <!-- <td>{{ item.uuid }}</td> -->
            <td>{{ item.question }}</td>
            <td>{{ item.answer }}</td>

            <td
              v-if="
                common.hasPermissions('llm', ['update']) ||
                common.hasPermissions('llm', ['delete'])
              "
            >
              <v-layout row wrap justify-center>
                <v-icon
                  v-if="common.hasPermissions('llm', ['update'])"
                  small
                  class="mr-2"
                  @click="edit(item)"
                  >mdi-pencil</v-icon
                >
                <v-icon
                  v-if="common.hasPermissions('llm', ['delete'])"
                  small
                  @click="openDeleteDialog(item)"
                  >mdi-delete</v-icon
                >
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import deleteDialog from "../../components/common/deleteDialog";
import common from "../../utils/common";
import QAForm from "./apps/QAForm";
export default {
  name: "qa-base",
  components: {
    QAForm,
    deleteDialog,
  },
  data() {
    return {
      common,
      search: "",
      filter: {
        status: "all",
      },
      showEdit: false,
      deleteDialog: false,
      statusColors: {
        active: "green",
        pending: "orange",
        failed: "red",
      },
      item: {},
    };
  },
  async mounted() {
    await this.getList();
  },
  computed: {
    bot() {
      return this.$store.state.bot;
    },
    list() {
      return this.$store.getters["llm/qa/get"];
    },

    headers() {
      return [
        // { text: "UUID", value: "uuid" },
        { text: "Question", value: "question" },
        { text: "Answer", value: "answer" },
        { text: "Actions", value: "action", align: "center" },
      ];
    },
  },
  methods: {
    async getList() {
      await this.$store.dispatch("llm/qa/get", { botID: this.bot.botId });
    },
    edit(item) {
      this.item = item;
      this.showEdit = true;
    },
    openDeleteDialog(item) {
      this.item = item;
      this.deleteDialog = true;
    },
    async deleteItem(item) {
      await this.$store.dispatch("llm/qa/delete", {
        botID: this.bot.botId,
        id: item.uuid,
      });

      this.deleteDialog = false;
      await this.getList();
    },
  },
};
</script>
